export default "__VITE_ASSET__B25Ovze5__"